import './main.css'

import { ThemeProvider } from '@mui/material/styles'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.tsx'
import {
  AuthContextProvider,
  HeaderAdminContextProvider,
  SidebarContextProvider,
} from './contexts'
import { MuiTheme } from './global/theme.ts'

import '@uppy/core/dist/style.min.css'

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={MuiTheme}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthContextProvider>
            <SidebarContextProvider>
              <HeaderAdminContextProvider>
                <App />
              </HeaderAdminContextProvider>
            </SidebarContextProvider>
          </AuthContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
)
